import { useState } from "react";
import AddEventModal from "../admin/AddEventModal.jsx";
import SmartEventsGen from "../admin/SmartEventsGen.jsx";
import JsonEventsImporter from "../admin/JsonEventsImporter.jsx";
import "../admin/admin.css";

export default function Admin() {
    const [activeTab, setActiveTab] = useState("addEvent");

    const tabs = [
        { id: "addEvent", label: "Manual" },
        { id: "aiEvents", label: "AI search" },
        { id: "jsonEvents", label: "JSON import" },
        { id: "settings", label: "Settings" },
    ];

    return (
        <main className="admin-page">
            <section className="admin-shell">
                <header className="admin-header">
                    <div>
                        <p className="admin-eyebrow">UnicorNation</p>
                        <h1>Admin workspace</h1>
                    </div>
                    <p className="admin-header-copy">
                        Create, import, and manage event data.
                    </p>
                </header>

                <div className="admin-tabs-scroll">
                    <div className="admin-tabs" role="tablist" aria-label="Admin sections">
                        {tabs.map((tab) => (
                            <button
                                type="button"
                                key={tab.id}
                                id={`tab-${tab.id}`}
                                role="tab"
                                aria-selected={activeTab === tab.id}
                                aria-controls={`panel-${tab.id}`}
                                tabIndex={activeTab === tab.id ? 0 : -1}
                                onClick={() => setActiveTab(tab.id)}
                                className="admin-tab"
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div
                    className="admin-panel"
                    id={`panel-${activeTab}`}
                    role="tabpanel"
                    aria-labelledby={`tab-${activeTab}`}
                >
                    {activeTab === "addEvent" && <AddEventModal />}
                    {activeTab === "aiEvents" && <SmartEventsGen />}
                    {activeTab === "jsonEvents" && <JsonEventsImporter />}
                    {activeTab === "settings" && (
                        <div className="admin-panel-intro">
                            <div>
                                <h2>Site settings</h2>
                                <p>No configurable site settings are available yet.</p>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </main>
    );
}
